import {formTransformer, profileToFormTransformer} from 'utils';

export const sportsmanToFormTransformer = sportsman => {
    if (!sportsman) {
        return null;
    }
    const { profile = {} } = sportsman;
    const transformedProfile = profileToFormTransformer(profile);

    return {
        ...formTransformer(sportsman, ['rank', 'qualification', 'trainer', 'secondTrainer']),
        ...(profile ? {profile: transformedProfile} : {}),
    };
}
